module.exports = __webpack_public_path__ + "img/upperabs-mesomorph-male.e919cdab.svg";